export default "__VITE_ASSET__722b74b0__"